<!--  -->
<template>
  <div class="container">
    <van-sticky>
      <van-nav-bar style="position:sticky" @click-left="goback" left-arrow fixed title="求职档案"></van-nav-bar>
    </van-sticky>
    <van-pull-refresh v-model="isRefresh" @refresh="onRefresh">
      <van-list
        v-model="isLoading"
        :finished="isFinished"
        finished-text="没有更多了"
        @load="onLoad"
        class="van-list-wrap"
      >
        <van-sticky :offset-top="50">
          <form action="javascript:return true" style="width: 100%;background: #fff;">
            <van-search
              @search="onSearch"
              @cancel="onCancel"
              v-model="value"
              shape="round"
              placeholder="搜索姓名/手机号或期望工种"
              type="search"
            />
          </form>
          <div class="num-wrap">
            <div class="num-item">
              <div class="num">{{ dataBoard.totalCount }}</div>
              <div class="txt">累计录入</div>
            </div>
            <div class="num-item">
              <div class="num">{{ dataBoard.nodeManagerEntry }}</div>
              <div class="txt">站长录入</div>
            </div>
            <div class="num-item">
              <div class="num">{{ dataBoard.independentEntry }}</div>
              <div class="txt">自主录入</div>
            </div>
            <div class="num-item">
              <div class="num">{{ dataBoard.signUpCount }}</div>
              <div class="txt">成功报名</div>
            </div>
            <div class="num-item">
              <div class="num">{{ dataBoard.recommendCount }}</div>
              <div class="txt">成功推荐</div>
            </div>
          </div>

          <van-tabs
            v-model="activeTab"
            @change="handlerTab"
            swipeable
            color="#3699FF"
            title-active-color="#3699FF"
          >
            <van-tab v-for="(item) in kinds" :key="item.key" :title="item.label"></van-tab>
          </van-tabs>
        </van-sticky>

        <div v-for="(item, index) in list" :key="index" class="job-wrap">
          <div class="job-info" @click="goDetail(item.id)">
            <div class="title-info">
              <div class="title">{{ item.expectWorkTypeName }}</div>
              <div class="money">{{ item.expectIncomeRange }}/月</div>
            </div>
            <div class="limit-wrap">
              <div class="limit-info">
                <span>
                  <div class="icon">
                    <img src="../../../assets/migrantFiles/icon-xingming.png" alt />
                    {{ item.applicantName }}
                  </div>
                  <div class="split-line"></div>
                </span>
                <span>
                  <div class="icon">
                    <img src="../../../assets/migrantFiles/icon-age.png" alt />
                    {{ item.age }}
                  </div>
                  <div class="split-line"></div>
                </span>
                <span>
                  <div class="icon">
                    <img v-if="item.sex == '男'" src="../../../assets/migrantFiles/boy.png" alt />
                    <img v-if="item.sex == '女'" src="../../../assets/migrantFiles/girl.png" alt />
                    {{ item.sex }}
                  </div>
                </span>
              </div>
              <div class="tel">
                电话：
                <a
                  :href="'tel:' + item.mobile"
                  @click.stop="telPreview"
                  class="call"
                >{{ item.mobile }}</a>
                <!-- <van-icon name="phone" color="#249edd" ><van-icon> -->
              </div>
              <div class="address">
                <span>
                  <label>期望地址：</label>
                  <div>{{ item.expectWorkAddress }}</div>
                </span>
              </div>
              <div class="date">{{ item.createTime }}</div>
            </div>
          </div>
        </div>
      </van-list>
    </van-pull-refresh>
  </div>
</template>

<script>
import { getWorkApplicantsList, getDataBoard } from "../../../api/migrantFiles";
import { Toast } from "vant";

export default {
  data() {
    return {
      activeTab: "",
      tabType: "all",
      dataBoard: {},
      kinds: [
        { label: "全部", key: "all " },
        { label: "站长录入", key: "node_manager" },
        { label: "自主录入", key: "independent" },
        { label: "成功报名", key: "success_sign_up" },
        { label: "成功推荐", key: "success_recommend" },
      ],

      isRefresh: false, //是否处于加载中状态
      isLoading: false, //是否处于加载状态
      isFinished: true, //数据是否加载完

      value: "",
      pageNum: 1,
      pageSize: 10,
      list: [],

    };
  },
  //生命周期 - 创建完成（访问当前this实例）
  created() {
    this.pageNum = 1;
    this.list = [];
    this.value = "";
    this.getList();
    this.getDataBoard();
  },
  //生命周期 - 挂载完成（访问DOM元素）
  mounted() { },
  methods: {
    telPreview() { },
    handlerTab() {
      this.pageNum = 1;
      this.tabType = this.kinds[this.activeTab].key;
      this.onSearch()
    },
    getDataBoard() {
      getDataBoard().then(res => {
        if (res.code == 200) {
          this.dataBoard = res.data;
        }
      })
    },
    goDetail(id) {
      this.$router.push({
        path: "/migrantFiles/myJobDetail",
        query: {
          id: id,
          fromPath: true
        }
      })
    },
    onSearch(val) {
      this.pageNum = 1;
      this.value = val;
      this.list = [];
      this.getList();
    },
    onCancel() {
      this.value = "";
    },
    getList() {
      Toast.loading({
        message: "加载中...",
        forbidClick: true,
      });
      console.log(this.value);
      let params = {
        workTypeName: this.value,
        pageSize: this.pageSize,
        pageNum: this.pageNum,
        tabType: this.tabType,
      };
      getWorkApplicantsList(params)
        .then((res) => {
          Toast.clear()
          if (res.code == 200) {
            let newList = res.data.list;

            this.isRefresh = false; //数据查询成功取消加载中状态
            for (let i = 0; i < newList.length; i++) {
              this.list.push(newList[i]);
            }
            this.isLoading = false; //不处于加载状态

            this.isFinished = true; //数据加载完
            if (this.list.length >= res.data.total) {
              this.isFinished = true; //数据加载完
            } else {
              this.isFinished = false; //数据加载完
            }
            if (this.list.length == 0) {
              Toast('抱歉，没有相关内容');
            }
          } else {
            this.isRefresh = false; //数据查询失败取消加载中状态

            this.isLoading = false; //不处于加载状态

            this.isFinished = true; //数据加载完，不会再处于加载状态

          }
        })
        .catch((err) => {
          this.isRefresh = false; //数据查询失败取消加载中状态

          this.isLoading = false; //不处于加载状态

          this.isFinished = true; //数据加载完，不会再处于加载状态

          Toast.loading({
            message: "加载中...",
            forbidClick: false,
          });
        });
    },
    onRefresh() {
      console.log(44444444);
      this.pageNum = 1;
      this.list = [];
      this.value = "";

      this.isLoading = true; //处于加载状态
      this.getList();
      this.getDataBoard();
    },
    onLoad() {
      // 接口
      this.pageNum++;
      this.isRefresh = false;
      this.getList();
    },
    goback() {
      this.$router.back();
    },
  }
};
</script>
<style lang='less' scoped>
/* @import url(); 引入css类 */
.van-nav-bar.van-nav-bar--fixed.van-hairline--bottom {
  height: 50px !important;
}
.container {
  box-sizing: border-box;
  background: #f7f7f7;
  .van-list-wrap > div:first-child {
    position: fixed;
    width: 100%;
  }

  .num-wrap {
    display: flex;
    align-items: center;
    justify-content: space-evenly;
    font-size: 16px;
    background: #3699ff;
    padding: 25px 0;
    color: #fff;
    .num-item {
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
      .num {
        margin-bottom: 12px;
      }
    }
  }
  .job-wrap {
    background: #fff;
    padding: 20px;
    margin-bottom: 10px;

    .job-info {
      .title-info {
        display: flex;
        justify-content: space-between;
        .title {
          width: 210px;
          font-size: 16px;
          font-weight: bold;
          color: #333333;
          line-height: 22px;
        }
        .money {
          font-size: 15px;
          font-weight: bold;
          color: #d70000;
          line-height: 22px;
        }
      }
      .limit-wrap {
        .limit-info {
          display: flex;
          align-items: center;
          font-size: 14px;
          font-weight: 400;
          color: #7e7d7d;
          margin: 15px 0;
          span {
            padding: 0 5px;
            display: flex;
            align-items: center;
            .icon {
              display: flex;
              align-items: center;
              img {
                width: 13px;
                height: 13px;
              }
            }
            .split-line {
              width: 1px;
              height: 10px;
              border-right: 1px solid #999999;
              margin-left: 10px;
            }
            &:first-child {
              padding-left: 0;
            }
          }
        }
        .tel {
          display: flex;
          align-items: center;
          font-size: 14px;
          font-weight: 400;
          color: #343434;
          margin: 10px 0;
          .call {
            margin-right: 5px;
          }
          span {
            font-weight: 400;
            color: #0085ff;
          }
        }
        .address {
          margin: 10px 0 0;
          display: flex;
          font-weight: 400;
          span {
            display: flex;
            font-size: 14px;
            color: #343434;
            label {
              min-width: 70px;
            }
          }
        }
        .date {
          font-size: 14px;
          color: #696969;
          text-align: right;
          margin-top: 5px;
        }
      }
    }
  }
  .van-list-wrap {
    .job-wrap:nth-child(2) {
      padding-top: 220px;
    }
  }
}
</style>